export const defaultClientBranch = (company, selectedBranch = null) => {
  if (selectedBranch?.id) {
    return selectedBranch;
  }

  const branches = Array.isArray(company?.branches)
    ? company.branches
    : Array.isArray(company?.branches?.items)
    ? company.branches.items
    : [];
  const configuredBranch = branches.find(branch => branch?.id === company?.defaultClientLocationId);

  return configuredBranch || branches[0] || null;
};
